/** Consume SSE from either a cloud conversation or a temporary guest chat. */
export async function consumeReply(response, onEvent) {
  if (!response.body) throw new Error("No response stream was returned.");
  const reader = response.body.getReader(),
    decoder = new TextDecoder();
  let buffer = "",
    complete = false;
  const consume = (block) => {
    const lines = block.split("\n");
    const event = lines
      .find((l) => l.startsWith("event:"))
      ?.slice(6)
      .trim();
    const data = lines
      .filter((l) => l.startsWith("data:"))
      .map((l) => l.slice(5).trim())
      .join("\n");
    if (!event || !data) return;
    const value = JSON.parse(data);
    if (event === "error")
      throw new Error(value.message || "The reply was interrupted.");
    if (event === "done") complete = true;
    onEvent(event, value);
  };
  try {
    for (;;) {
      const { value, done } = await reader.read();
      buffer = (buffer + decoder.decode(value, { stream: !done })).replace(
        /\r\n/g,
        "\n",
      );
      let split;
      while ((split = buffer.indexOf("\n\n")) >= 0) {
        consume(buffer.slice(0, split));
        buffer = buffer.slice(split + 2);
      }
      if (done) {
        if (buffer.trim()) consume(buffer);
        break;
      }
    }
    if (!complete)
      throw new Error(
        "Connection interrupted before the reply was saved. Refresh or retry.",
      );
  } finally {
    reader.releaseLock();
  }
}
